module.exports = __webpack_public_path__ + "static/18-115842aaab8e6f512f2ed97cda413f38.jpg";